import React from 'react';
import { connect } from 'react-redux';

import { getOrganization } from 'selectors';
import TaskCompletionNotifications from 'pages/emailNotifications/components/taskCompletionNotifications';
import CertificateReadyNotifications from 'pages/emailNotifications/components/certificateReadyNotifications';

const EmailNotifications = ({ organization }) => {
  return (
    <div className="block">
      <h2 className="mb-4">Email Notifications</h2>
      <TaskCompletionNotifications />
      <CertificateReadyNotifications />
    </div>
  );
};

function mapStateToProps(state) {
  return { organization: getOrganization(state) };
}

export default connect(mapStateToProps)(EmailNotifications);
